var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Great news! Your switch "),(_vm.supplier)?_c('span',[_vm._v("to "),_c('b',[_vm._v(_vm._s(_vm.supplier.name))]),_vm._v(" at "+_vm._s(_vm.currentPropertyAddress))]):_vm._e(),_vm._v(" is complete. ")])}
var staticRenderFns = []

export { render, staticRenderFns }